import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../store';
import { resetComplaintState } from '../../../../store/complaint';
import { closeFeedbackComplaintPopup } from '../../../actions/feedback';
import { Complaint, IComplaintProps } from './index';
import { getComplaints } from '../../../../store/complaint/get_complaints';

export type TStoreFields = Pick<
  IComplaintProps,
  'offer' | 'complaints' | 'isComplaintAdded' | 'isLoading' | 'errorMessage' | 'isOpen' | 'sendFeedbackStatus'
>;
export type TActions = Pick<IComplaintProps, 'getComplaints' | 'resetComplaintState' | 'onClose'>;

export function mapStateToProps(state: IState): TStoreFields {
  const { status } = state.complaintFeedbackFrom;

  return {
    offer: state.offerData.offer,
    complaints: state.complaint.complaints,
    errorMessage: state.complaint.errorMessage,
    isComplaintAdded: state.complaint.isComplaintAdded,
    isLoading: state.complaint.isLoading,
    isOpen: state.feedback.isComplaintPopupOpened,
    sendFeedbackStatus: status,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): TActions {
  return {
    getComplaints: (category: number) => dispatch(getComplaints(category)),
    onClose: () => dispatch(closeFeedbackComplaintPopup()),
    resetComplaintState: () => dispatch(resetComplaintState()),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FeedbackComplaintPopupContainer = connect<TStoreFields, TActions, any>(
  mapStateToProps,
  mapDispatchToProps,
)(Complaint);
